import { render, staticRenderFns } from "./MdrlEditAppr.vue?vue&type=template&id=015e157a&scoped=true&"
import script from "./MdrlEditAppr.vue?vue&type=script&lang=js&"
export * from "./MdrlEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015e157a",
  null
  
)

export default component.exports